// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class ImageParallax extends WebComponent {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.animate = this.animate.bind(this);
  }

  didMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.timeout = null;
    this.imageHeight = this.element.offsetHeight;
  }

  handleScroll = () => {
    if (window.scrollY < this.imageHeight) {
      window.requestAnimationFrame(() => this.animate(window.scrollY * 0.4));
    }
  };

  animate = (shift) => {
    this.element.style.transform = `translate3d(0px, ${shift}px, 0px)`;
  };

  willUnMount() {}
  update() {}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ImageParallax.js